(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('angular'), require('ng-metadata/core')) :
	typeof define === 'function' && define.amd ? define(['exports', 'angular', 'ng-metadata/core'], factory) :
	(factory((global['gaf-ng-components-click-tracking'] = {}),global.angular,global.core));
}(this, (function (exports,angular,core) { 'use strict';

var __decorate$1 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/**
 * @ngdoc service
 * @name mwClickTrackingService
 * @module mw.components.clickTracking
 *
 * @description
 * A service used by the `mw-click-tracking` directive to make calls to node-tracking.
 *
 */
/**
 * @ngdoc method
 * @name mwClickTrackingService#trackClick
 * @param {String} trackingEvent The path to call in node-tracking to register the click event
 * @param {Object} data The payload to send to node-tracking to register the click event
 *
 * @description
 * Makes the call to node-tracking.
 * For information on node-tracking routes and payloads, <a href="https://github.com/meltwater/node-tracking">check the github page for our swagger documentation.</a>
 *
 */
var ClickTrackingService = /** @class */ (function () {
    function ClickTrackingService($http, $log, trackingUrl) {
        'ngInject';
        this.$http = $http;
        this.$log = $log;
        this.trackingUrl = trackingUrl;
    }
    ClickTrackingService.prototype.trackClick = function (trackingEvent, data) {
        var message, _this = this;
        data.source = 'webapp';
        return this.$http.post(this.trackingUrl + '/' + trackingEvent, data).then(function handleSuccess() { }, function handleError(error) {
            message = 'Encountered an error while tracking a "' + trackingEvent + '" event';
            _this.$log.error(message);
            _this.$log.error(error);
            throw message;
        });
    };
    ClickTrackingService.prototype.trackContextMenuOpen = function (data) {
        var message, _this = this;
        return this.$http.post(this.trackingUrl + '/contextMenu/open', data).then(function handleSuccess() { }, function handleError(error) {
            message = 'Encountered an error while tracking a "contextMenu/open" event';
            _this.$log.error(message);
            _this.$log.error(error);
            throw message;
        });
    };
    ClickTrackingService = __decorate$1([
        core.Injectable(),
        __param(0, core.Inject('$http')),
        __param(1, core.Inject('$log')),
        __param(2, core.Inject('CLICK_TRACKING_URL')),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], ClickTrackingService);
    return ClickTrackingService;
}());

var __decorate$2 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param$1 = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/**
 * @ngdoc directive
 * @name mwClickTracking
 * @module mw.components.clickTracking
 * @restrict A
 *
 * @description
 * `mw-click-tracking` is an attribute directive that will listen for clicks and make calls to node-tracking.
 * The value of this attribute must be a stringified object containing payloads to be sent to node-tracking.
 *
 * Placing a `data-tracking-event` attribute on the element that needs click tracking is required to fire the tracking event to
 * node-tracking and its value must be the route you wish to send the tracking event to.
 * This data attribute can be placed on the same element as the `mw-click-tracking` directive
 * or on a child element. This was done to enable components to remain agnostic to the context in which they are
 * implemented.
 *
 * The `data-tracking-event` value must match a field in the directive's payload object. This was done so that a single
 * directive attribute can be responsible for multiple tracking events.
 *
 * Additional payload fields can be added by placing the `data-tracking-event-add-payload` attribute on the click event target.
 *
 * For information on node-tracking routes and payloads, <a href="https://github.com/meltwater/node-tracking">check the github page for our swagger documentation.</a>
 *
 * @usage
 * <hljs hljs-language="html">
 * <div mw-click-tracking="{'documentOperation/open': {'userId': '{{::searchResultsController.userId}}', 'companyId': '{{::searchResultsController.companyId}}', 'parentType': 'search', 'documentId': '{{::document.documentId}}', 'savedSearchId': '{{::searchResultsController.savedSearchData.savedSearchId}}'}}">
 *     <div data-tracking-event="documentOperation/open"></div>
 * </div>
 * </hljs>
 *
 * <hljs hljs-language="html">
 * <div data-tracking-event="featureOperation/success" data-tracking-event-add-payload="{'featureName': 'twitterEngagement'}" mw-click-tracking="{'featureOperation/success': {'userId': '{{::searchResultsController.userId}}', 'companyId': '{{::searchResultsController.companyId}}'}}"></div>
 * </hljs>
 */
var ClickTrackingDirective = /** @class */ (function () {
    function ClickTrackingDirective(mwClickTracking, $log) {
        'ngInject';
        this.mwClickTracking = mwClickTracking;
        this.$log = $log;
    }
    ClickTrackingDirective.prototype.contextMenuClickOnHostElement = function ($event) {
        var target = $event.target;
        if (target) {
            // check $event target ancestors for the data-tracking-event attribute
            // ignore clicks without this attribute
            var trackingEventElement = this.getTrackingEventElement(target);
            if (trackingEventElement) {
                var trackingEvent = this.getTrackingEvent(trackingEventElement);
                // call out to the click tracking service if we have a payload and an event
                if (trackingEvent) {
                    this.mwClickTracking.trackContextMenuOpen({ event: trackingEvent });
                }
            }
        }
    };
    ClickTrackingDirective.prototype.clickOnHostElement = function ($event) {
        var target = $event.target, parsedData = this.getParsedData();
        if (target && parsedData) {
            // check $event target ancestors for the data-tracking-event attribute
            // ignore clicks without this attribute
            var trackingEventElement = this.getTrackingEventElement(target);
            if (trackingEventElement) {
                var trackingEvent = this.getTrackingEvent(trackingEventElement), trackingEventPayload = this.buildTrackingEvent(trackingEventElement, parsedData);
                // call out to the click tracking service if we have a payload and an event
                if (trackingEvent && trackingEventPayload) {
                    this.mwClickTracking.trackClick(trackingEvent, trackingEventPayload);
                }
            }
        }
    };
    ClickTrackingDirective.prototype.getTrackingEventElement = function (target) {
        return target.closest('[data-tracking-event]');
    };
    ClickTrackingDirective.prototype.getParsedData = function () {
        try {
            // try to parse the data
            return JSON.parse(this.data);
        }
        catch (err) {
            this.$log.error('An error occurred while parsing the click tracking data');
            this.$log.error(this.data);
            this.$log.error(err);
        }
    };
    ClickTrackingDirective.prototype.buildTrackingEvent = function (trackingElement, parsedData) {
        var trackingPayload, trackingEvent = trackingElement.getAttribute('data-tracking-event'), additionalPayload = trackingElement.getAttribute('data-tracking-event-add-payload');
        trackingPayload = parsedData[trackingEvent];
        if (!trackingPayload) {
            return false;
        }
        if (additionalPayload) {
            var parsedAdditionalPayload = void 0;
            try {
                // try to parse the data
                parsedAdditionalPayload = JSON.parse(additionalPayload);
            }
            catch (err) {
                this.$log.error('An error occurred while parsing the additional payload for click tracking data');
                this.$log.error(this.data);
                this.$log.error(err);
            }
            trackingPayload = Object.assign(trackingPayload, parsedAdditionalPayload);
        }
        return trackingPayload;
    };
    ClickTrackingDirective.prototype.getTrackingEvent = function (trackingElement) {
        var trackingEvent = trackingElement.getAttribute('data-tracking-event');
        if (trackingEvent) {
            return trackingEvent;
        }
        else {
            return false;
        }
    };
    __decorate$2([
        core.Input('mwClickTracking'),
        __metadata$1("design:type", Object)
    ], ClickTrackingDirective.prototype, "data", void 0);
    __decorate$2([
        core.HostListener('contextmenu', ['$event']),
        __metadata$1("design:type", Function),
        __metadata$1("design:paramtypes", [Object]),
        __metadata$1("design:returntype", void 0)
    ], ClickTrackingDirective.prototype, "contextMenuClickOnHostElement", null);
    __decorate$2([
        core.HostListener('click', ['$event']),
        __metadata$1("design:type", Function),
        __metadata$1("design:paramtypes", [Object]),
        __metadata$1("design:returntype", void 0)
    ], ClickTrackingDirective.prototype, "clickOnHostElement", null);
    ClickTrackingDirective = __decorate$2([
        core.Directive({
            selector: '[mwClickTracking]'
        }),
        __param$1(0, core.Inject('mwClickTracking')),
        __param$1(1, core.Inject('$log')),
        __metadata$1("design:paramtypes", [Object, Object])
    ], ClickTrackingDirective);
    return ClickTrackingDirective;
}());

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @ngdoc module
 * @name mw.components.clickTracking
 * @description
 *
 * Click Tracking
 */
var ClickTrackingModule = /** @class */ (function () {
    function ClickTrackingModule() {
    }
    ClickTrackingModule = __decorate([
        core.NgModule({
            declarations: [ClickTrackingDirective],
            providers: [{ provide: 'mwClickTracking', useClass: ClickTrackingService }]
        })
    ], ClickTrackingModule);
    return ClickTrackingModule;
}());

'use strict';
var index = angular.module('mwClickTracking', [
    core.bundle(ClickTrackingModule).name
]);

exports['default'] = index;

Object.defineProperty(exports, '__esModule', { value: true });

})));



/*****************
 ** WEBPACK FOOTER
 ** ./~/@meltwater/gaf-ng-components-click-tracking/gaf-ng-components-click-tracking.umd.js
 ** module id = 79
 ** module chunks = 0 1
 **/